import type { EditorPreviewCardEntry } from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';

export const previewCardEntry: EditorPreviewCardEntry = {
  id: ComponentIdentifiers.rAccordion,
  // The disclosure triangle a closed <summary> draws, pointing the way it
  // points while the detail is collapsed. A question mark would name the FAQ
  // case at the expense of every other use of a disclosure, and stacked bars
  // are already the List card.
  icon: '▸',
  label: 'Accordion',
};
